<template>
  <div class="payment-page" v-loading="state.loading">
    <div class="header-nav">
      <!--<button class="back-btn" @click="handleBack">&lt;</button>-->
      <div class="nav-title">订单支付</div>
    </div>
    <div class="timer-bar">
      <span class="time">支付剩余时间: {{ formatTime(state.countdown) }}</span>
    </div>

    <div class="content-wrapper">
      <div class="order-card card">
        <div class="order-header">
          <div class="order-title">订单支付</div>
          <div class="order-subtitle">
            <img
              :src="state.orderInfo?.Mxs?.[0]?.SpFm"
              class="product-image"
              v-if="state.orderInfo?.Mxs?.[0]?.SpFm"
            />
            <span class="highlight-text">{{
              state.orderInfo?.Mxs?.[0]?.SpMc || "-"
            }}</span>
          </div>
          <div class="order-date">
            使用日期：{{ formatDate(state.orderInfo?.Mxs?.[0]?.Syrq || "-") }}
          </div>
        </div>

        <div class="order-info">
          <div class="info-item">
            <span class="label">订单编号</span>
            <span class="value">{{ state.orderInfo.Bh || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">下单时间</span>
            <span class="value">{{ formatDate(state.orderInfo.Cjsj) }}</span>
          </div>
          <div class="info-item">
            <span class="label">联系人</span>
            <span class="value">{{ state.orderInfo.Yklxrxm || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">联系方式</span>
            <span class="value">{{ state.orderInfo.Yklxrsj || "-" }}</span>
          </div>
          <div class="info-item">
            <span class="label">游玩人</span>
            <span class="value">{{ state.orderInfo.YkCount || 0 }}人</span>
          </div>
          <div class="info-item">
            <span class="label">备注</span>
            <span class="value">{{ state.orderInfo.Bz || "-" }}</span>
          </div>
        </div>
      </div>

      <div class="ticket-list card">
        <div class="section-title">门票信息</div>
        <div
          class="ticket-item"
          v-for="item in state.orderInfo.Mxs"
          :key="item.Id"
        >
          <div class="ticket-name">{{ item.SpTcMc }}</div>
          <div class="ticket-meta">
            <span class="price">¥{{ formatPrice(item.Xsdj) }}</span>
            <span class="quantity">x{{ item.Sl }}</span>
            <span class="total">小计：¥{{ formatPrice(item.Xszj) }}</span>
          </div>
        </div>
      </div>

      <div class="payment-methods card">
        <div class="section-title">支付方式</div>
        <div
          class="method-item"
          :class="{ active: state.paymentMethod === 'Wx' }"
          @click="state.paymentMethod = 'Wx'"
        >
          <div class="method-icon wechat">
            <div class="payment-code-bg"></div>
          </div>
          <div class="method-info">
            <div class="method-name">微信支付</div>
          </div>
          <div class="method-check"></div>
        </div>
      </div>

      <div class="bottom-space"></div>
    </div>

    <div class="footer">
      <div class="price-info">
        <div class="label">合计金额</div>
        <div class="amount">¥{{ formatPrice(state.orderInfo.TotalPrice) }}</div>
      </div>
      <el-button type="primary" class="pay-button" @click="handlePayment">
        立即支付
      </el-button>
    </div>
  </div>
</template>

<style scoped>
.product-image {
  width: 40px;
  height: 40px;
  margin-right: 8px;
  vertical-align: middle;
  border-radius: 4px;
}
.highlight-text {
  font-weight: bold;
  font-size: 16px;
  color: #2c3e50;
}

.method-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
}
.method-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.method-info {
  flex: 1;
}
.method-name {
  font-weight: 500;
  margin-bottom: 4px;
}
.method-desc {
  font-size: 12px;
  color: #666;
}
.method-check {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
}
.method-item.active .method-check {
  background-color: #1677ff;
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import { reactive, onMounted, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { dayjs, ElMessage } from "element-plus";
import { huifu_createH5 } from "@/http/api";
import { shangpindingdan_detailAny, huifu_getopenid } from "@/http/api";

export default {
  setup() {
    const route = useRoute();
    const router = useRouter();

    const handleBack = () => {
      router.go(-1);
    };
    const query = reactive({});
    const state = reactive({
      loading: false,
      countdown: 1800, // 30分钟倒计时
      paymentMethod: "Wx",
      orderInfo: {},
    });

    // 格式化日期
    const formatDate = (dateStr) => {
      return dateStr ? dayjs(dateStr).format("YYYY-MM-DD HH:mm") : "-";
    };

    // 格式化价格
    const formatPrice = (price) => {
      return Number(price || 0).toFixed(2);
    };

    // 格式化倒计时
    const formatTime = (seconds) => {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    };

    // 获取订单详情
    const loadOrderDetail = () => {
      state.loading = true;
      console.log("API请求参数:", route.params.orderId, query.ph, query._t);
      shangpindingdan_detailAny(route.params.orderId, query.ph, query._t)
        .then((res) => {
          console.log("API响应状态:", res.status);
          console.log("API响应数据:", res.data);
          if (res.status === 200) {
            state.orderInfo = res.data;
            console.log("设置订单数据后:", state.orderInfo);
            // 计算总金额
            state.orderInfo.TotalPrice = res.data.Mxs.reduce((sum, item) => {
              return sum + (item.Xsdj || 0) * (item.Sl || 0);
            }, 0);
          }
        })
        .finally(() => {
          state.loading = false;
        });
    };

    // 处理支付
    const handlePayment = () => {
      state.loading = true;
      state.openid = "";
      if (state.paymentMethod == "Wx") {
        const url = window.location.href;
        const beginIndex = url.indexOf("code");
        const endIndex = url.indexOf("&");
        if (beginIndex < 0 || endIndex < 0) {
          //如果url中不包含code参数，由于微信的回调地址不支持hash模式的路由，所以地址中不能带有#号，所以整体地址为：http://ra.gujinghotels.com:82/?code=8Maea6TwUpVhQ1qqE893kQzxyJD9qVwPVPFi560VXsc&state=STATE#/?storeid=1
          state.statusCode = 400;
          return false;
        }
        state.weChatCode = window.location.href.slice(beginIndex + 5, endIndex);
        huifu_getopenid(state.weChatCode).then((res) => {
          if (res.status == 200) {
            state.openid = res.data;
          }
        });
      }
      huifu_createH5(state.paymentMethod, {
        DdId: route.params.orderId,
        OpenId: state.openid,
      })
        .then((res) => {
          if (res.status === 200) {
            if (typeof res.data === "object" && state.paymentMethod == "Wx")
              wechatPay(res.data);
            if (typeof res.data === "object" && state.paymentMethod == "Zfb")
              window.location.href = res.data;
          }
        })
        .finally(() => {
          state.loading = false;
        });
    };

    const wechatPay = (result) => {
      //封装请求微信支付接口数据
      var request_data = {
        appId: result.appId,
        timeStamp: result.timeStamp,
        nonceStr: result.nonceStr,
        package: result.package,
        signType: "RSA",
        paySign: result.paySign,
      };

      window.WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        request_data,
        (res) => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            ElMessage({ type: "success", message: "支付成功" });
          }
        }
      );
    };

    // 倒计时定时器
    let countdownTimer;
    onMounted(() => {
      query.ph = route.query.ph;
      query._t = route.query._t;
      loadOrderDetail();
      countdownTimer = setInterval(() => {
        if (state.countdown > 0) {
          state.countdown--;
        } else {
          clearInterval(countdownTimer);
          // 倒计时结束，跳回订单列表
          router.push({ name: "H5ShangPin" });
        }
      }, 1000);
    });

    // 清理定时器
    watch(
      () => route.path,
      () => {
        clearInterval(countdownTimer);
      }
    );

    return {
      handleBack,
      state,
      formatDate,
      formatPrice,
      formatTime,
      handlePayment,
    };
  },
};
</script>

<style scoped>
.payment-page {
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
}

.timer-bar {
  background-color: #e8f3ff;
  color: #1890ff;
  padding: 8px 12px;
  text-align: center;
  font-size: 14px;
}

.content-wrapper {
  padding: 12px;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  margin-bottom: 12px;
}

.order-header {
  margin-bottom: 16px;
}

.order-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.order-subtitle {
  color: #909399;
  font-size: 14px;
  margin-bottom: 8px;
}

.order-date {
  color: #606266;
  font-size: 14px;
}

.order-info {
  border-top: 1px dashed #eee;
  padding-top: 16px;
}

.info-item {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: 14px;
}

.info-item .label {
  color: #909399;
}

.info-item .value {
  color: #303133;
}

.section-title {
  font-weight: 600;
  margin-bottom: 12px;
  color: #303133;
  font-size: 16px;
}

.ticket-item {
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
}

.ticket-item:last-child {
  border-bottom: none;
}

.ticket-name {
  font-size: 15px;
  margin-bottom: 8px;
  color: #303133;
}

.ticket-meta {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.ticket-meta .price {
  color: #f56c6c;
}

.ticket-meta .quantity {
  color: #606266;
}

.header-nav {
  padding: 15px;
  display: flex;
  align-items: center;
  position: relative;
}

.back-btn {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  position: absolute;
  left: 15px;
}

.nav-title {
  font-size: 18px;
  font-weight: bold;
  margin: 0 auto;
}

.ticket-meta .total {
  font-weight: 600;
  color: #303133;
}

.payment-methods {
  margin-top: 12px;
}

.method-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f5f5f5;
  cursor: pointer;
}

.method-item:last-child {
  border-bottom: none;
}

.method-icon {
  width: 40px;
  height: 60px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  background-color: #fff;
}

.payment-code-bg {
  width: 50px;
  height: 40px;
  background-image: url("~@/assets/images/paycode.png");
  background-size: 99%;
  background-repeat: no-repeat;
}

.alipay {
  background-color: #1677ff;
}

.method-name {
  flex: 1;
  font-size: 15px;
  color: #303133;
}

.method-check {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #ddd;
  position: relative;
}

.method-item.active .method-check {
  background-color: #1890ff;
  border-color: #1890ff;
}

.method-item.active .method-check::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 8px;
  height: 4px;
  border-left: 2px solid white;
  border-bottom: 2px solid white;
}

.footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  padding: 12px;
  background: #fff;
  box-shadow: 0 -4px 10px rgba(0, 0, 0, 0.04);
  z-index: 1000;
}

.price-info {
  margin-right: 16px;
  text-align: right;
}

.label {
  font-size: 14px;
  color: #606266;
}

.amount {
  font-size: 18px;
  font-weight: 700;
  color: #f56c6c;
}

.pay-button {
  flex: 1;
  height: 48px;
  font-size: 16px;
  border-radius: 24px;
}

.bottom-space {
  height: 80px;
}

@media (min-width: 768px) {
  .payment-page {
    max-width: 720px;
    margin: 0 auto;
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
  }
}
</style>
